import React from "react";
import { Modal, Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { useNetworkManager } from "../../contexts/NetworkManagerContext/NetworkManagerContext";
import { useHomeBridge } from "../../contexts/HomeBridgeContext";
import { useDestinationBridge } from "../../contexts/DestinationBridgeContext";
import { modalClasses } from "../../utils/classes";
import { OutlinedButton } from "../../components/Button";

interface IChangeNetworkDrawerProps {
  open: boolean;
  close: () => void;
}

const ChangeNetworkDrawer: React.FC<IChangeNetworkDrawerProps> = ({
  open,
  close,
}) => {
  const { setWalletType, handleSetHomeChain, setDestinationChain } =
    useNetworkManager();
  const { disconnect } = useHomeBridge();
  const destinationBridge = useDestinationBridge();
  const theme = useTheme();

  return (
    <Modal open={open}>
      <Box sx={modalClasses}>
        <Typography
          variant="h3"
          color="#ffffff"
          fontWeight={700}
          fontSize={theme.spacing(6)}
          mb={theme.spacing(5)}
        >
          Changing networks
        </Typography>
        <Typography
          component="p"
          color={theme.palette.secondary.contrastText}
          fontWeight={500}
          mb={theme.spacing(7)}
        >
          To change networks, please open your browser wallet and change
          networks there. If your wallet does not support your desired home
          network, please connect a different wallet. <br />
          Note: your transfer settings will be reset.
        </Typography>
        <Box display="flex" gap={theme.spacing(5)}>
          <OutlinedButton variant="outlined" onClick={close}>
            OK
          </OutlinedButton>
          <OutlinedButton
            variant="outlined"
            onClick={async () => {
              // TODO: trigger unsubscribes & clear all state
              await Promise.all([destinationBridge.disconnect(), disconnect()]);
              handleSetHomeChain(undefined);
              setDestinationChain(undefined);
              setWalletType("select");
            }}
          >
            Connect different wallet
          </OutlinedButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default ChangeNetworkDrawer;
